export default{
    state: {
        order_id: null,
        errors: {},
        meta: {
            order_id: null,
            current_page: 1,
            per_page: "10",
            total: 0,
            from: '',
            to: '',
            sort: 'desc',
            order_by: 'Choose',
            sort_by: 'created_at',
            sort_desc: true,
            search: '',
            page_sizes: [10, 25, 50, 100],
        },
        table: {
            fields: [
                {key: 'id', label: 'code', sortable: true},
                {key: 'date', label: 'Date', sortable: true},
                {key: 'request_code', label: 'Request Code', tdClass: 'text-muted'},
                {key: 'facility', label: 'Facility', tdClass: 'text-muted'},
                {key: 'store', label: 'Store', tdClass: 'text-muted'},
                {key: 'supplier', label: 'Supplier', tdClass: 'text-muted'},
                {key: 'item', label: 'Item', tdClass: 'text-muted'},
                {key: 'tax', label: 'Tax', tdClass: 'text-muted'},
                {key: 'discount', label: 'Discount', tdClass: 'text-muted'},
                {key: 'payment_term', label: 'Payment Term', tdClass: 'text-muted'},
                {key: 'actions', label: 'Actions', thClass: 'text-center', tdClass: 'text-center'},
            ]
        },
        form: {
            code: '',
            date: null,
            request_code: '',
            supplier_id: '',
            facility_id: '',
            store_id: '',
            item_id: '',
            tax: '',
            dsicount: '',
            payment_term: '',
            notes: '',
        },
    },

    getters: {
        getOrderMeta: state => state.meta,

        getOrderTableFields: state => state.table.fields,

        getOrderForm: state => state.form,

        getOrderErrors: state => state.errors,
    },

    mutations: {
        resetOrdersMeta: state => {
            state.meta = {
                current_page: 1,
                per_page: 10,
                total: 0,
                from: '',
                to: '',
                sort: 'desc',
                order_by: 'Choose',
                sort_by: 'created_at',
                sort_desc: true,
                search: '',
                page_sizes: [10, 25, 50, 100],
            };
        },

        setOrders: (state, payload) => {
            state.categories = payload;
        },

        setOrdersMeta: (state, payload) => {
            state.meta = {...state.meta, ...payload};
        },

        setOrderForm: state => {
            state.form = {
                code: '',
                date: null,
                request_code: '',
                requested_by: '',
                supplier_id: '',
                facility_id: '',
                store_id: '',
                item_id: '',
                tax: '',
                dsicount: '',
                payment_term: '',
                notes: '',
            };

            state.errors = {};
        },

        setOrderErrors: (state, payload) => {
            state.errors = payload;
        },
    },

    actions: {
        fetchOrders: ({state, commit}) => {
            let parameters = {
                page: state.meta.current_page,
                per_page: state.meta.per_page,
                sort_by: state.meta.sort_by,
                sort: state.meta.sort,
                search: state.meta.search,
            };


            if (!parameters.search && parameters.search.length <= 3) {
                delete parameters.search;
            }

            const order = {
                "data": [
                    {
                        "order_id": 1,
                        "label": "Order1",
                        "data": {
                            "type": "Order",
                            "attributes": {
                                "code": "PRU000001",
                                "request_code": "REQ000001",
                                "date": "12-12-12",
                                "type": "damage",
                                "facility": "NB-001 - Cedar Harbor Residence [V-IR] [I-DR]",
                                "store": "1",
                                "supplier": "New-man",
                                "tax": "$50",
                                "discount": "10%",
                                "payment_term": "Credit",
                                "item": "i-phone",
                            }
                        },
                        "links": {"self": "order\/1"}
                    },
                    {
                        "order_id": 2,
                        "label": "Order2",
                        "data": {
                            "type": "Order",
                            "attributes": {
                                "code": "PRU000002",
                                "request_code": "REQ000002",
                                "date": "17-02-11",
                                "type": "order",
                                "facility": "NB-002 - Meridian House [V-IR] [I-DR]",
                                "store": "u W u",
                                "supplier": "New-man",
                                "tax": "$50",
                                "discount": "15%",
                                "payment_term": "Cash",
                                "item": "him-phone",
                            }
                        },
                        "links": {"self": "order\/2"}
                    },
                    {
                        "order_id": 3,
                        "label": "Order3",
                        "data": {
                            "type": "Order",
                            "attributes": {
                                "code": "PRU000003",
                                "request_code": "REQ000002",
                                "date": "26-12-12",
                                "type": "expired",
                                "facility": "NB-002 - Meridian House [V-IR] [I-DR]",
                                "store": "1",
                                "supplier": "New-man",
                                "tax": "$50",
                                "discount": "12.5%",
                                "payment_term": "Cookies",
                                "item": "nokia-3310",
                            }
                        },
                        "links": {"self": "order\/3"}
                    },
                ],
                "links": {
                    "self": "\/order",
                    "first": "http:\/\/pilot.test\/api\/inventory\/orders\/order?page=1",
                    "last": "http:\/\/pilot.test\/api\/inventory\/orders\/order?page=3",
                    "prev": null,
                    "next": "http:\/\/pilot.test\/api\/inventory\/orders\/order?page=2"
                },
                "meta": {
                    "current_page": 1,
                    "from": 1,
                    "last_page": 3,
                    "path": "http:\/\/pilot.test\/api\/inventory\/orders\/order",
                    "per_page": "10",
                    "to": 10,
                    "total": 21
                }
            };

            return new Promise((resolve, reject) => {
                commit('setOrders', order);

                commit('setOrdersMeta', order.meta);

                resolve(order);
            });
        },

        fetchEditOrder: ({state, commit}, order_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + order_id + '/edit')
                    .then(response => {
                        state.order_id = response.data.id;

                        state.form = response.data;

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        submitOrder: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setOrderErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        updateOrder: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.order_id, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setOrderErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        deleteOrder: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.delete(state.url + '/' + payload.order_id)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            })
        },
    }
}
